
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';

  export default defineComponent({
    name: 'ads-brokerage-configuration-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('adsBrokerageConfigListing'), [
          translate('ads'),
        ]);
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_ADS_BROKERAGE_CONFIGS_STORE);
      });

      await store.dispatch(Actions.GET_ADS_BROKERAGE_CONFIGS);
      console.log(store.getters.adsBrokerageConfigsList);

      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('idColumn'),
          key: 'id',
          sortable: true,
        },
        {
          name: translate('slug'),
          key: 'slug',
          sortable: true,
        },
        {
          name: translate('brokerName'),
          key: 'brokerName',
          sortable: true,
        },
        {
          name: translate('agentName'),
          key: 'agentName',
          sortable: true,
        },
        {
          name: translate('phone'),
          key: 'phone',
        },
        {
          name: translate('status'),
          key: 'isActive',
          sortable: true,
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);

      const deleteConfig = async (config) => {
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          text: translate('confirmDelete'),
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-danger',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(Actions.DELETE_ADS_BROKERAGE_CONFIG, config.id);
          await store.dispatch(Actions.GET_ADS_BROKERAGE_CONFIGS);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          } else {
            Swal.fire({
              text: translate('SUCCESSFULLY_DELETED'),
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: translate('ok'),
              customClass: {
                confirmButton: 'btn btn-light-primary',
              },
            });
          }
        }
      };

      const editConfig = (id) => {
        router.push({
          name: 'ads-brokerage-configuration-editing',
          params: { id },
        });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_ADS_BROKERAGE_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_ADS_BROKERAGE_CONFIGS);
        loading.value = false;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        tableData: computed(() => store.getters.adsBrokerageConfigsList),
        tableHeader,
        deleteConfig,
        translate,
        totalItems: computed(() => store.getters.adsBrokeragesListCount),
        pageChanged,
        goTo,
        editConfig,
        loading,
        can,
      };
    },
  });
